import React from "react";
import { createRoot } from "react-dom/client";
import ReactGA from "react-ga4";

import App from "./App";
import "./i18n";

// Inicialización de Google Analytics (GA4)
const measurementId = process.env.GA_MEASUREMENT_ID;
if (measurementId) {
  ReactGA.initialize(measurementId);
  ReactGA.send("pageview");
  console.log("Google Analytics 4 inicializado correctamente.");
} else {
  console.warn(
    "Google Analytics 4 no inicializado: GA_MEASUREMENT_ID no definido en el archivo .env."
  );
}

const container = document.getElementById("app");
const root = createRoot(container);
root.render(<App />);
